import { combineReducers } from 'redux';
import widgetReducer from './widgetReducer';

const appReducer = combineReducers({
  widget: widgetReducer,
});

const rootReducer = (state, action) => {
  const updatedState = state;

  return appReducer(updatedState, action);
};

export default rootReducer;
